import React from "react";
import { useParams } from "react-router";
import { EditTransactionWizard } from "./EditTransactionWizard";

export const EditTransactionWizardWithRouting = () => {
  const { id } = useParams<"id">();

  return <EditTransactionWizard id={Number.parseInt(id!)} />;
};
